"use client";

import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { twMerge } from "tailwind-merge";

const clamp = (n) => Math.min(100, Math.max(0, Number(n ?? 0)));

const Progress = React.forwardRef(
  ({ className, indicatorClassName, value = 0, ...props }, ref) => {
    const v = clamp(value);
    return (
      <ProgressPrimitive.Root
        ref={ref}
        value={v}
        className={twMerge(
          // sensible defaults; can be overridden by className
          "relative w-full overflow-hidden rounded-full bg-indigo-50 h-2",
          className
        )}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className={twMerge(
            // default color; override if you use tokens like bg-primary
            "h-full w-full flex-1 bg-indigo-600 transition-transform",
            indicatorClassName
          )}
          style={{ transform: `translateX(-${100 - v}%)` }}
        />
      </ProgressPrimitive.Root>
    );
  }
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
